import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch, getState } from '@@/store';
import { Table, Form, DatePicker, Select, Button } from 'antd';
import { TableContainer } from '@/components';
import Mapping from '@/shared/mapping';
const { RangePicker } = DatePicker;
const Option = Select.Option;
const mapStateToProps = (rootState) => ({
    _state: rootState.margin,
});
class MarginForm extends Component {
    constructor() {
        super(...arguments);
        this.onChange = () => {
            const e = this.props.form.getFieldsValue();
            dispatch.margin.SET_PARAMS(e);
            dispatch.margin.SET_PAGE_CURRENT(1);
            dispatch.margin.load({});
        };
        this.changePage = (e) => {
            dispatch.margin.SET_PAGE_CURRENT(e);
            dispatch.margin.load({});
        };
        this.getExport = () => {
            // 搜索栏
            const { params: _params, id, name } = getState().margin;
            // 是否是卖家
            const { isSeller } = getState().router.query;
            // 获取导出的label和value
            const { seller_detail_data, buyer_detail_data } = Mapping.excelExportType;
            const exportType = isSeller === 'true' ? seller_detail_data.value : buyer_detail_data.value;
            const exportObj = {
                type: 'finance',
                params: Object.assign(Object.assign({}, _params), { userId: id, exportType }),
                fileName: isSeller === 'true' ? `${seller_detail_data.label}_${name}` : `${buyer_detail_data.label}_${name}`,
            };
            return exportObj;
        };
    }
    componentWillMount() {
        dispatch.margin.load({});
    }
    componentWillUnmount() {
        dispatch.margin.RESET_STATE();
    }
    render() {
        const { totalNum, data, columns, options, pageIndex, pageSize, tableLoading, } = this.props._state;
        const { getFieldDecorator } = this.props.form;
        const exportObj = this.getExport();
        return (<TableContainer totalNum={totalNum} exportObj={exportObj}>
        <Form layout="inline">
          <Form.Item label="时间">
            {getFieldDecorator('time')(<RangePicker style={{ width: '240px' }}/>)}
          </Form.Item>
          <Form.Item label="明细类型">
            {getFieldDecorator('type')(<Select style={{ width: '240px' }} placeholder="请选择明细类型">
                {options.map((opt, i) => (<Option key={`opt_${i}`} value={opt.value}>{opt.label}</Option>))}
              </Select>)}
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={this.onChange}>搜索</Button>
          </Form.Item>
        </Form>
        <Table dataSource={data} columns={columns} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: totalNum,
            onChange: this.changePage,
        }} loading={tableLoading}/>
      </TableContainer>);
    }
}
const Margin = Form.create()(MarginForm);
export default connect(mapStateToProps)(Margin);
